// Toque de telefone em loop enquanto houver ligação chegando pra mim.
// WebAudio sintetizado: nenhum asset novo, som distinto do "ding" e parada
// imediata com suspend(). Para via stopRingtone quando a fila esvazia ou
// quando uma ligação está em curso.
import { useAlert } from 'dashboard/composables';
import { useWhatsappCallsStore } from 'dashboard/stores/whatsappCalls';
import DashboardAudioNotificationHelper from 'dashboard/helper/AudioAlerts/DashboardAudioNotificationHelper';

const CYCLE_MS = 2000;
const ALERT_DURATION = 10000;
// Tempo pra decidir se o autoplay foi bloqueado: num contexto permitido o state vira
// "running" logo depois do resume(); num bloqueado a promise do resume() nem resolve.
const PERMISSION_CHECK_MS = 500;
let ctx = null;
let timer = null;
let askedPermission = false;
let armedGesture = false;

// Só silencia quem desligou os alertas sonoros de propósito (Perfil > Notificações sonoras).
// Quem nunca configurou (ui_settings vazio) recebe o toque. always_play_audio_alert NÃO é
// respeitado de propósito: o telefone toca mesmo com a aba em foco.
const soundOff = () =>
  DashboardAudioNotificationHelper.currentUser?.ui_settings
    ?.enable_audio_alerts === 'none';

function beep(at, freq, dur) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, at);
  gain.gain.linearRampToValueAtTime(0.35, at + 0.02);
  gain.gain.setValueAtTime(0.35, at + dur - 0.03);
  gain.gain.linearRampToValueAtTime(0, at + dur);
  osc.connect(gain).connect(ctx.destination);
  osc.start(at);
  osc.stop(at + dur);
}

// Dois tons curtos (660 e 880 Hz) e silêncio até completar 2 s.
function cycle() {
  const t = ctx.currentTime;
  beep(t, 660, 0.35);
  beep(t + 0.45, 880, 0.35);
}

function play() {
  if (timer || !useWhatsappCallsStore().ringing) return;
  cycle();
  timer = setInterval(cycle, CYCLE_MS);
}

// Autoplay bloqueado (nenhum gesto ainda): o resume() fica pendente até o primeiro gesto,
// então o destrave e o aviso ficam fora do .then. O resume() dentro do pointerdown libera
// o contexto e o play() (idempotente) começa o loop se ainda houver ligação tocando.
function armGestureUnlock() {
  if (armedGesture) return;
  armedGesture = true;
  document.addEventListener('pointerdown', () => ctx.resume().then(play), {
    once: true,
  });
}

function warnIfBlocked() {
  setTimeout(() => {
    if (ctx.state === 'running' || askedPermission) return;
    askedPermission = true;
    useAlert(
      'PROFILE_SETTINGS.FORM.AUDIO_NOTIFICATIONS_SECTION.SOUND_PERMISSION_ERROR',
      { usei18n: true, duration: ALERT_DURATION }
    );
  }, PERMISSION_CHECK_MS);
}

export function startRingtone() {
  if (timer || soundOff()) return;
  ctx ||= new (window.AudioContext || window.webkitAudioContext)();
  ctx.resume().then(play);
  armGestureUnlock();
  warnIfBlocked();
}

export function stopRingtone() {
  clearInterval(timer);
  timer = null;
  if (ctx?.state === 'running') ctx.suspend();
}
